module.exports = __webpack_public_path__ + "static/media/tr.b5d0dcb6.svg";